<rt-placeholder-category-select-dropdown
  [header]="'app.wyswig.placeholders.replace_with' | translate"
  [placeholders]="filteredPlaceholders"
  [selectFooterTemplate]="footerTemplate"
  (select)="emitPlaceholderChange($event)"
>
</rt-placeholder-category-select-dropdown>

<ng-template #footerTemplate>
  <rt-dropdown-header
    [uppercase]="false"
    (mousedown)="deletePlaceholder($event, active)"
    class="clickable"
  >
    <div layout layout-align-items-center>
      <rt-icon name="remove-circle" size="small-x" [isLight]="true" margin-right-small-x></rt-icon>
      {{ 'app.common.remove' | translate }}
    </div>
  </rt-dropdown-header>
</ng-template>
